export default __webpack_public_path__ + "static/media/Pratik Paul_ Resume.02d35736.pdf";